<template>
    <div id="#App"> 
        <div class="" style="position: absolute; top: 1rem; right: 1rem;">
          <img class="dropdown-arrow " style="width: 10px; height: 54px; " src="./assets/dropdown-arrow-white.svg">
          <select class="user-input dimmed px1 rounded small" style="color:var(--medium-gray);border: 2px solid var(--color-darkgray);background:transparent;width: 124px; height: 54px;" v-model="$i18n.locale" @change="callRecalculateStiffness(); switchLocale()">
            <option class="white"
              v-for="(lang, i) in langs"
              :key="`Lang${i}`"
              :value="lang.value"
              >{{ lang.label }}</option
            >
          </select>
        </div>

        <div v-if="isDev == 'true'" class="dev-flag">
          <p>Achtung! Sie befinden sich im Development-System.</p>
        </div>
        <div v-if="isStage == 'true'" class="stage-flag">
          <p>Achtung! Sie befinden sich im Stage-System.</p>
        </div>

      <router-view></router-view>
      <!-- <p class="version-number">Version: 1.09012</p> -->
    </div>
</template>

<script>

import axios from 'axios';
import { EventBus } from "./event-bus";
export default {
  name: "App",
  data() {
    return {
      debug: false,
      step: 'eingabe',
      userdata: {},
      session: {},
      loginStatus: false,
      langs: [
        {value: 'de', label: 'Deutsch'}, 
        {value: 'en', label: 'English (metric)'}, 
      ],
      isDev: process.env.VUE_APP_IS_DEV,
      isStage: process.env.VUE_APP_IS_STAGE,
      apiEndpoint: process.env.VUE_APP_APIENDPOINT
    };
  },
  created: function () {


    console.log('API ENDPOINT process.env:')
    console.log(process.env.VUE_APP_APIENDPOINT)
    console.log('API ENDPOINT process.env from data():')
    console.log(this.apiEndpoint)


    console.log('Browser Language: ' + navigator.language)
    console.log('Locale: ' + this.$i18n.locale)
    if(this.$i18n.locale !== 'de' && this.$i18n.locale !== 'en'){
      if(navigator.language.startsWith('de')){
        console.log('Language set to de')
        this.$i18n.locale = 'de'
        this.switchLocale();
      }
      if(navigator.language.startsWith('en')){
        console.log('Language set to en')
        this.$i18n.locale = 'en'
        this.switchLocale();
      }
    }

    EventBus.$on('loginSuccessful', (payload) => {
      //console.log('App.vue recieved Event: "loginSuccessful"!');

      

      this.userdata = payload.userdata;
      this.session = payload.session;

      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/initapp';

        
        axios.post(url, this.session);

      this.loginStatus = true;

    });
    EventBus.$on('loginCheckQaL', () => {
      //console.log('App.vue recieved Event: "loginCheckQaL"!');

      if(this.loginStatus) {
        
       //console.log('App.vue sends Event: "loginSuccessfulSubComponents"!');
        EventBus.$emit('loginSuccessfulSubComponents', {
          "userdata": this.userdata,
          "session": this.session,
        });
      } else {
        
        //console.log('Can not perfom login-Validation!');
        EventBus.$emit('loginNotCorrect',{});
      }
    });
  },
  components: {

   },
  methods: {
    callRecalculateStiffness(){
      console.log('call recalculate stiffness')
      EventBus.$emit('call_recalculate_stiffness')

    },
    switchLocale() {

        var locale = this.$i18n.locale;
        const to = this.$router.resolve({ params: {lang: locale} }) // <--------------------
        this.$router.push(to.location).catch(err => {
          if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          console.log(err);
        }
            })
        },
  }
}
</script>

<style lang="scss">
@import './css/styles.scss';

</style>
